<i18n>
{
    "ru": {
        "subscribers_one": "подписчик",
        "subscribers_few": "подписчика",
        "subscribers_many": "подписчиков",

        "subscription_one": "подписка",
        "subscription_few": "подписки",
        "subscription_many": "подписок",

        "milliliters_one": "миллилитр",
        "milliliters_few": "миллилитра",
        "milliliters_many": "миллилитров",

        "points_one": "поинт",
        "points_few": "поинта",
        "points_many": "поинтов",

        "level": "уровень"
    }
}
</i18n>
<template>
    <div class="profile-info-counts">
        <div class="profile-info-count">
            <router-link
                v-if="isPersonal"
                :to="getRoute('points')"
                class="profile-info-count__link">
                <span class="profile-info-count__num">{{ points | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ pointsDeclension(points) }}</span>
            </router-link>
            <div
                v-else
                class="profile-info-count__item">
                <span class="profile-info-count__num">{{ points | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ pointsDeclension(points) }}</span>
            </div>
        </div>

        <div class="profile-info-count">
            <router-link
                v-if="isPersonal || (isStranger && !isLock && subscriptionNum > 0)"
                :to="getRoute('subscriptions')"
                class="profile-info-count__link">
                <span class="profile-info-count__num">{{ subscriptionNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ subscriptionDeclension(subscriptionNum) }}</span>
            </router-link>
            <div
                v-else
                class="profile-info-count__item">
                <span class="profile-info-count__num">{{ subscriptionNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ subscriptionDeclension(subscriptionNum) }}</span>
            </div>
        </div>

        <div class="profile-info-count">
            <router-link
                v-if="isPersonal || (isStranger && !isLock && subscribersNum > 0)"
                :to="getRoute('subscribers')"
                class="profile-info-count__link">
                <span class="profile-info-count__num">{{ subscribersNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ subscribersDeclension(subscribersNum) }}</span>
            </router-link>
            <div
                v-else
                class="profile-info-count__item">
                <span class="profile-info-count__num">{{ subscribersNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ subscribersDeclension(subscribersNum) }}</span>
            </div>
        </div>

        <div class="profile-info-count">
            <router-link
                v-if="isPersonal"
                :to="getRoute('milliliters')"
                class="profile-info-count__link">
                <span class="profile-info-count__num">{{ millilitersNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ millilitersDeclension(millilitersNum) }}</span>
            </router-link>
            <div
                v-else
                class="profile-info-count__item">
                <span class="profile-info-count__num">{{ millilitersNum | numberShortFormat }}</span>
                <span class="profile-info-count__name">{{ millilitersDeclension(millilitersNum) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
export default {
    name: 'ProfileCounts',
    props: {
        points: {
            type: Number,
            default: 0
        },
        subscriptionNum: {
            type: Number,
            default: 0
        },
        subscribersNum: {
            type: Number,
            default: 0
        },
        millilitersNum: {
            type: Number,
            default: 0
        },
        profileType: {
            type: String,
            default: 'personal'
        },
        isPersonal: {
            type: Boolean,
            default: false
        },
        isStranger: {
            type: Boolean,
            default: false
        },
        isLock: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        get,
        getRoute(name) {
            return {
                name: 'users.' + name,
                params: {
                    userId: get(this.$route, 'params.userId', undefined)
                }
            }
        },
        subscriptionDeclension(count) {
            const declensionArray = [
                this.$t('subscription_one'),
                this.$t('subscription_few'),
                this.$t('subscription_many')
            ];
            return this.$options.filters.numberDeclension(count, declensionArray, false)
        },
        subscribersDeclension(count) {
            const declensionArray = [
                this.$t('subscribers_one'),
                this.$t('subscribers_few'),
                this.$t('subscribers_many')
            ];
            return this.$options.filters.numberDeclension(count, declensionArray, false)
        },
        millilitersDeclension(count) {
            const declensionArray = [
                this.$t('milliliters_one'),
                this.$t('milliliters_few'),
                this.$t('milliliters_many')
            ];
            return this.$options.filters.numberDeclension(count, declensionArray, false)
        },
        pointsDeclension(count) {
            const pointsArray = [
                this.$t('points_one'),
                this.$t('points_few'),
                this.$t('points_many')
            ];
            return this.$options.filters.numberDeclension(count, pointsArray, false)
        }
    }
}
</script>

<style lang="less">
.profile-info-count {

    &__item,
    &__link {
        color: @color-gray;
        text-align: center;
        margin: 0 rem(8);
        display: block;

        @media @media-less-375{
            margin: 0 rem(3);
        }

        @{desktop} & {
            margin: 0 rem(24) 0 0;
            text-align: left;
        }
    }

    &__num {
        color: @color-black;
        font-weight: 500;
        line-height: 1.4;
        display: block;
    }

    &__name {
        font-size: rem(12);
        font-weight: 400;
        text-transform: lowercase;
        display: block;
        .animate(color);
    }

    .hover({
        a.profile-info-count__link{
            .profile-info-count__name {
                color: @color-black;
            }
        }
    });
}
</style>
